export class ConfiguratorEventEmitter extends EventTarget {}
